import { render } from "./BottomTicker.vue?vue&type=template&id=ccd271a4&scoped=true"
import script from "./BottomTicker.vue?vue&type=script&lang=js"
export * from "./BottomTicker.vue?vue&type=script&lang=js"

import "./BottomTicker.vue?vue&type=style&index=0&id=ccd271a4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccd271a4"]])

export default __exports__